import { type AnimationEvent, createContext } from "react";

export const ActivityAnimationContext = createContext<{
  live: boolean;
  activityId: string;
} | null>(null);

export const activityAnimationPeriod = "2s";

// Pinning every start to the timeline origin keeps rows that begin animating at different moments in phase.
export function alignToTimeline(event: AnimationEvent<HTMLElement>) {
  if (event.target !== event.currentTarget) return;
  for (const animation of event.currentTarget.getAnimations())
    if (
      animation instanceof CSSAnimation &&
      animation.animationName === event.animationName
    )
      animation.startTime = 0;
}
